/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmEmployeeData
 */
export interface ConfirmEmployeeData {
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmployeeData
     */
    token: string;
}

/**
 * Check if a given object implements the ConfirmEmployeeData interface.
 */
export function instanceOfConfirmEmployeeData(value: object): value is ConfirmEmployeeData {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ConfirmEmployeeDataFromJSON(json: any): ConfirmEmployeeData {
    return ConfirmEmployeeDataFromJSONTyped(json, false);
}

export function ConfirmEmployeeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmployeeData {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

  export function ConfirmEmployeeDataToJSON(json: any): ConfirmEmployeeData {
      return ConfirmEmployeeDataToJSONTyped(json, false);
  }

  export function ConfirmEmployeeDataToJSONTyped(value?: ConfirmEmployeeData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

